import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
  button: (customStyle) => ({
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontSize: 12,
    lineHeight: "15px",
    fontWeight: 700,
    paddingTop: 11,
    paddingBottom: 11,
    paddingLeft: 16,
    paddingRight: 16,
    borderWidth: 1,
    border: "solid",
    ...customStyle
  }),
  buttonItems: {
    gap: 10,
    display: "flex",
    alignItems: "center"
  },
}));
